import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { StoreProvider } from 'easy-peasy'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import 'react-medium-image-zoom/dist/styles.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import stores from '@/stores'
import { locales } from '@/locales'

import reportWebVitals from './reportWebVitals'
import { router } from './routes/router'

// Initialize Firebase (Analytics auto-starts when REACT_APP_FIREBASE_* env vars are set)
import '@/utils/firebase'

import './index.css'

const last_update = '2025-10-14 13.55'

if (process.env.NODE_ENV === 'production') {
	console.log = () => {}
	console.error = () => {}
	console.debug = () => {}
}

i18n.use(initReactI18next).init({
	resources: locales,
	lng: 'id',
	fallbackLng: 'id',
	interpolation: {
		escapeValue: false
	}
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<StoreProvider store={stores}>
		<RouterProvider router={router} />
	</StoreProvider>
)

reportWebVitals()
